import * as constants from './constants';

const defaultState = {
    venueDetail: [],
    siteList: [],
};
export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.VENUE_DETAIL:
            return {...state, venueDetail: action.value};
        case constants.SITE_LIST:
            return {...state, siteList: action.value};
        default:
            return state;
    }
}